import { createFileRoute, redirect } from '@tanstack/react-router'
import z from 'zod/v3'
import { ROLE_EDIT } from '~/components/routes/administration/roles/permissions'
import { withRoutePermissions } from '~/utils/rbac'

/**
 * `/administration/roles/$roleId/edit` redirige vers `/administration/access` en ouvrant la modale
 * d'édition du rôle. La garde `ROLE_EDIT` est conservée : un lien entrant sans ce droit tombe sur
 * la page refusée avant la redirection.
 */
export const Route = createFileRoute('/_authenticated/administration/roles/$roleId/edit')({
  staticData: { permission: ROLE_EDIT },
  params: {
    parse: z.object({ roleId: z.coerce.number() }).parse,
  },
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/administration/access',
      search: { roleForm: 'edit', roleId: params.roleId },
    })
  },
})
withRoutePermissions(Route)
